import { IFunctionPermissions } from "../common/api_interfaces/role/IFunctionPermissions";

export function hasPermission(userAccess: IFunctionPermissions[], functionCode: string, permissionCode: string): boolean {
    const funcAccess = userAccess.find((xx) => xx.functionCode === functionCode);
    if (!funcAccess) return false;
    return funcAccess.permissions.some((yy) => yy.permissionCode === permissionCode && yy.isGranted === true);
}
